<script lang="ts">
  import { observe } from "$lib/actions/observe";
  import { sanitizeSvg } from "$lib/utils/sanitize";

  let {
    sectionLabel = "",
    headline = "",
    description = "",
    values = [] as Array<{
      icon: string;
      text: string;
    }>
  } = $props();
</script>

<section>
  <div class="container">
    {#if sectionLabel}
      <div class="section-divider fade-up" use:observe>
        <span class="section-label">{sectionLabel}</span>
        <h2>{headline}</h2>
        {#if description}
          <p>{description}</p>
        {/if}
      </div>
    {/if}
    <div class="values-grid stagger" use:observe style="text-align:center">
      {#each values as value}
        <div class="card">
          {#if value.icon}
            <div class="card-icon" aria-hidden="true" style="background:var(--accent-bg);color:var(--accent);margin:0 auto 12px">
              {@html sanitizeSvg(value.icon)}
            </div>
          {/if}
          <p style="font-size:0.85rem">{value.text}</p>
        </div>
      {/each}
    </div>
  </div>
</section>
